import { useCallback } from 'react';

import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

import { ToolKitItem } from './toolkitUtils';

export type HomepageToolkitSpec = {
  homepage?: {
    toolkit?: {
      default?: ToolKitItem[];
      byGroup?: Record<string, ToolKitItem[]>;
    };
  };
};

export function useHomepageToolkit() {
  const catalogApi = useApi(catalogApiRef);

  return useCallback(async (): Promise<HomepageToolkitSpec> => {
    const entity = await catalogApi.getEntityByRef(
      'component:default/pe-misc-homepage-toolkit-configuration',
    );

    if (!entity?.spec) {
      return { homepage: { toolkit: { default: [] } } };
    }

    return entity.spec as HomepageToolkitSpec;
  }, [catalogApi]);
}
